import { render } from "./Applicant_Preferences.vue?vue&type=template&id=1825d0d8&scoped=true"
import script from "./Applicant_Preferences.vue?vue&type=script&lang=js"
export * from "./Applicant_Preferences.vue?vue&type=script&lang=js"

import "./Applicant_Preferences.vue?vue&type=style&index=0&id=1825d0d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1825d0d8"]])

export default __exports__